import React from 'react'

import { Nav } from '../../components/nav/Nav'
import { Hero } from '../../components/hero/Hero'
import { About } from '../../components/about/About'
import { Expertise } from '../../components/expertise/Expertise';
import { Projects} from '../../components/projects/Projects';
import { Contact } from '../../components/contact/Contact';
import { Footer } from '../../components/footer/Footer';


export const Home = () => {

      const showAnimation = () =>{
        let heroSection = document.querySelector('.hero_section')
        let aboutSection = document.querySelector('.about_section')
        let expertiseSection = document.querySelector('.skills_section')
        let projectSection = document.querySelector('.project_section')
        let contactSection = document.querySelector('.contact_section')

        let scrollPos  = window.scrollY;
        let sections = document.querySelectorAll('section')

        sections.forEach((sect) => {
          if(scrollPos <= 100 && heroSection != null){
            sect.classList.remove('show_animate')
            heroSection.classList.add('show_animate')
            return
          } else if(scrollPos <= 1265 && aboutSection != null){
            sect.classList.remove('show_animate')
            aboutSection.classList.add('show_animate')
            return
          } else if (scrollPos <= 1665 && expertiseSection != null){
            sect.classList.remove('show_animate')
            expertiseSection.classList.add('show_animate')

          } else if (scrollPos > 2150 && scrollPos < 2543 && projectSection != null){
            sect.classList.remove('show_animate')
            projectSection.classList.add('show_animate')

          } else if (scrollPos > 2900 && scrollPos < 3250 && contactSection != null){
            sect.classList.remove('show_animate')
            contactSection.classList.add('show_animate')

          }
        })

      }

      window.addEventListener('scroll', showAnimation)
  return (
    <>
    <Nav/>
    <Hero />
    <About/>
    <Expertise/>
    <Projects /> 
    <Contact/>
    <Footer/>
    </>
  )
}
